// extracted by mini-css-extract-plugin
module.exports = {"secblock":"security-module--secblock--d4GnE"};